import { createFeatureSelector, createSelector } from '@ngrx/store';

import { NotificationPreferencesState } from '../states/notification-preferences.state';
import { NOTIFICATION_PREFERENCES_REDUCER_KEY } from '../reducers/notification-preferences.reducer';

const getNotificationPreferencesState = createFeatureSelector<NotificationPreferencesState>(NOTIFICATION_PREFERENCES_REDUCER_KEY);

export const getUnsubscribeDetails$ = createSelector(getNotificationPreferencesState, state => state?.unsubscribeDetails);

export const getEmailPreferences$ = createSelector(getNotificationPreferencesState, state => state?.emailPreferences);

export const getNotificationPreferencesLoading$ = createSelector(getNotificationPreferencesState, state => state?.loading);

export const getNotificationPreferencesError$ = createSelector(getNotificationPreferencesState, state => state?.error);

export const getUnsubscribeSuccess$ = createSelector(getNotificationPreferencesState, state => state?.unsubscribeSuccess);

export const getDeleteSuccess$ = createSelector(getNotificationPreferencesState, state => state?.deleteSuccess);
